import React from "react";
import { HappeningMetadataProps } from "./HappeningMetadataProps.csharp";

export const HappeningMetadata = (props: HappeningMetadataProps) => {
    return (
        <section className="HappeningMetadata">
            {props.details.length === 1 && (
                <div className="HappeningMetadata__row">
                    {props.dateLabel && (
                        <span className="label">
                            <strong>{props.dateLabel}:</strong>
                        </span>
                    )}
                    <span className="value">{props.details[0]}</span>
                </div>
            )}
            {props.ageLimit && props.ageLimitLabel && (
                <div className="HappeningMetadata__row">
                    <span className="label">
                        <strong>{props.ageLimitLabel}:</strong>
                    </span>
                    <span className="value">{props.ageLimit}</span>
                </div>
            )}
            {props.doors && props.doorsLabel && (
                <div className="HappeningMetadata__row">
                    <span className="label">
                        <strong>{props.doorsLabel}:</strong>
                    </span>
                    <span className="value">{props.doors}</span>
                </div>
            )}
            {props.eventStart && props.eventStartLabel && (
                <div className="HappeningMetadata__row">
                    <span>
                        <strong>{props.eventStartLabel}:</strong>
                    </span>
                    <span>{props.eventStart}</span>
                </div>
            )}
            {props.duration && props.durationLabel && (
                <div className="HappeningMetadata__row">
                    <span>
                        <strong>{props.durationLabel}:</strong>
                    </span>
                    <span>{props.duration}</span>
                </div>
            )}
            {props.venue && props.venueLabel && (
                <div className="HappeningMetadata__row">
                    <span>
                        <strong>{props.venueLabel}:</strong>
                    </span>
                    <span>{props.venue}</span>
                </div>
            )}
            {props.setup && (
                <span>
                    <strong>{props.setup}</strong>
                </span>
            )}
        </section>
    );
};
